import { render, staticRenderFns } from "./QuickActions.vue?vue&type=template&id=6f7d0ab3&scoped=true"
import script from "./QuickActions.vue?vue&type=script&lang=js"
export * from "./QuickActions.vue?vue&type=script&lang=js"
import style0 from "./QuickActions.vue?vue&type=style&index=0&id=6f7d0ab3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7d0ab3",
  null
  
)

export default component.exports